
import Vue, { PropType } from "vue";
import KFieldGroup from "@/components/crud/fields/KFieldGroup.vue";
import KSelect from "@/components/crud/fields/KSelect.vue";
import KTextField from "@/components/crud/fields/KTextField.vue";
import { StockStatus } from "@/modules/stock/enums";

type ComponentData = {
  internalFilters: Record<string, any>;
};

export default Vue.extend({
  name: "StockFilter",
  computed: {
    StockStatus() {
      return StockStatus;
    },
  },
  components: {
    KFieldGroup,
    KSelect,
    KTextField,
  },
  props: {
    filters: {
      type: Object as PropType<Record<string, any>>,
      required: true,
    },
  },
  data: (): ComponentData => ({
    internalFilters: {
      stockStatus: undefined,
      status: undefined,
      stockMinimum: undefined,
    },
  }),
  watch: {
    filters: {
      handler(newFilters) {
        this.internalFilters = newFilters;
      },
      immediate: true,
      deep: true,
    },
    internalFilters: {
      handler(newFilters) {
        this.$emit("update:filters", newFilters);
      },
      deep: true,
    },
  },
});
